import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { RxIntuitiveTeethOrchestratorState, RxIntuitiveTeethOrchestratorStore } from './rx-intuitive-teeth-orchestrator-store';

@Injectable()
export class RxIntuitiveTeethOrchestratorQuery extends Query<RxIntuitiveTeethOrchestratorState> {
	viewMode$ = this.select(state => state.viewMode);

	get viewMode() {
		return this.getValue().viewMode;
	}

	constructor(protected store: RxIntuitiveTeethOrchestratorStore) {
		super(store);
	}
}
